import { RootState } from '@/store';
import { State } from './state';
import { ActionTree } from 'vuex';

import {
    FETCH_FUNCTIONALITY_LIST,
    CREATE_FUNCTIONALITY_LIST,
    SET_FUNCTIONALITY_LIST,
    UPDATE_REGISTER_FUNCTIONALITY_FORM_VISIBILITY,
    SET_REGISTER_FORM_VISIBILITY,
    UPDATE_SELECTED_FUNCTIONALITY,
    SET_SELECTED_FUNCTIONALITY,
    CREATE_NEW_FUNCTIONALITY,
    UPDATE_FUNCTIONALITY_LIST,
    UPDATE_FUNCTIONALITY,
    ADD_FUNCTIONALITY_TO_LIST,
    UPDATE_SYSTEM_FUNCTIONALITY,
    SET_SELECTED_FUNCTIONALITY_SYSTEM,
    FETCH_GROUPED_FUNCTIONALITY_LIST,
    SET_GROUPED_FUNCTIONALITY_LIST,
} from './types';
import { functionalityApi } from '@/api/functionality.api';
import { IFunctionality } from '@/modules/functionality/models';
import { ISystem } from '@/modules/system/models';
import { MessageService } from '@/services/messageService';


export const actions: ActionTree<State, RootState> = {
    async [FETCH_FUNCTIONALITY_LIST]({ commit }, isOnlyActive: boolean) {
        return functionalityApi.getAll(isOnlyActive).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [CREATE_FUNCTIONALITY_LIST]({ commit }, payload: State) {
        commit(SET_FUNCTIONALITY_LIST, payload);
    },
    async [UPDATE_REGISTER_FUNCTIONALITY_FORM_VISIBILITY]({ commit }, payload: boolean) {
        commit(SET_REGISTER_FORM_VISIBILITY, payload);
    },
    async [UPDATE_SELECTED_FUNCTIONALITY]({ commit }, payload: State) {
        commit(SET_SELECTED_FUNCTIONALITY, payload);
    },
    async [UPDATE_FUNCTIONALITY_LIST]({ commit }, payload: IFunctionality) {
        commit(ADD_FUNCTIONALITY_TO_LIST, payload);
    },
    async [CREATE_NEW_FUNCTIONALITY]({ commit }, payload: IFunctionality) {
        return functionalityApi.addFunctionality(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [UPDATE_FUNCTIONALITY]({ commit }, payload: IFunctionality) {
        return functionalityApi.updateFunctionality(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [UPDATE_SYSTEM_FUNCTIONALITY]({ commit }, payload: ISystem) {
        commit(SET_SELECTED_FUNCTIONALITY_SYSTEM, payload);
    },
    async [FETCH_GROUPED_FUNCTIONALITY_LIST]({ commit }, payload: State) {
        commit(SET_GROUPED_FUNCTIONALITY_LIST, (await functionalityApi.getAllGrouped()).data);
    },
};
